module.exports = __webpack_public_path__ + "static/media/Pin-Light-Delegacia.2d0cd5f1.svg";